import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage } from 'formik';

//components
import FormLabel from '../Label';
import ErrorField from '../ErrorField';
//styles
import { Input } from './index.styled';
import { FormGroup } from 'components/styled/Form.styled';

const TimeField = ({
  name,
  label,
  type,
  disabled,
  isRequired,
  error,
  min = '',
  value,
  defaultValue,
  mb = undefined,
}) => {
  return (
    <FormGroup mb={mb}>
      <FormLabel
        label={label}
        name={name}
        isRequired={isRequired}
        error={error}
        disabled={disabled}
      >
        {label}
      </FormLabel>
      <Input
        disabled={disabled}
        type={type || 'date'}
        name={name}
        error={error ? 'hasError' : 'noError'}
        min={min}
        value={value}
        defaultValue={defaultValue}
      />
      <ErrorMessage name={name} component={ErrorField} />
    </FormGroup>
  );
};

TimeField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  isRequired: PropTypes.bool,
  error: PropTypes.bool,
  min: PropTypes.oneOfType([PropTypes.oneOf([null]), PropTypes.string]),
  defaultValue: PropTypes.string,
  value: PropTypes.string,
};

export default TimeField;
